<template>
	<div class="tx">
		<header>
			<h1>
				<router-link to="/mine">
					<v-icon name="chevron-left" class="set_2"></v-icon>
				</router-link>
				<p class="set_1">余额</p>
			</h1>
		</header>
		<div class="txa">
			<div class="card">
				<p class="carda">银行</p>
				<router-link to="/mine/card">
				<p class="cardb">请选择银行卡</p>
				<v-icon name="angle-right" class="cardc"></v-icon>
				</router-link>
			</div>
			<div class="care">
				<p class="carea">提现</p>
				<input type="number" placeholder="请输入提现金额" class="careb">
			</div>
		</div>
		<button class="tixiancard" v-on:click="add()">提现余额</button>
		<div class="tc_nav">
			<span class="tc_navx"></span>
		</div>
	</div>
</template>
<script>
import $ from 'jquery';
import { CURL } from "../../lib/url.js";
export default {
data() {
	return {
		money:[],
		bank:[],
		cid:[]
	}
},
mounted(){
	function GetQueryString(name){
        var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
        var r = window.location.search.substr(1).match(reg);
        if(r!=null)return  unescape(r[2]); return null;
    }
	var id=GetQueryString("id");
	this.getAjax(id)
},
methods:{
	add:function(){
		var _bank= $('.cardb').text();
		var _money= $('.careb').val();
		var _cardid = this.cid
		var openid=localStorage.getItem("openid");
		console.log(this.money)
		if(_bank == '请选择银行卡'){
			$('.tc_navx').text('请选择银行卡')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else if(_money == '' || _money == null){
			$('.tc_navx').text('请填写提现金额')
			$('.tc_nav').fadeIn()
			setTimeout(function(){
				$('.tc_nav').fadeOut()
			},2000)
		}else{
        $.get(CURL+"/portal/All/gettixian",{"_bank":_bank,"_money":_money,"_cardid":_cardid,"openid":openid},function(data){
            // console.log(data);//获取ajax请求参数
            if(data.num == 1){
            	$('.tc_navx').text('提现成功 等待审核')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
//					location.href = '/mine';
					this.$router.push({path:'/mine'});
				},2000)
            }else if(data.num == 2){
                $('.tc_navx').text('提现金额大于账户余额')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
				},2000)
            }else if(data.num == 3){
                $('.tc_navx').text('提现金额大于最大提现金额')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
				},2000)
            }else if(data.num == 4){
                $('.tc_navx').text('提现金额小于最低提现金额')
				$('.tc_nav').fadeIn()
				setTimeout(function(){
					$('.tc_nav').fadeOut()
				},2000)
            }
        });
		}
    },
    getAjax:function (id) {
   		this.cid = id
	var successCallback =  (response) => {
	  console.log('success')
	  this.bank = response.bank
	  if(id != '' || id != null){
	  	for(var i=0;i<this.bank.length;i++){
	  		// console.log(this.bank[i].bank_id)
		  	if(id == this.bank[i].bank_id){
		  		//console.log("this.bank[i].bank_name"+this.bank[i].bank_name)
		  		$('.cardb').text(this.bank[i].bank_name)
		  	}
	  	}
	}
	}
	
	var errorCallback =  (response) => {
	    console.log('error')
	}
	var openid=localStorage.getItem("openid");
	this.$http.get(CURL+'/portal/All/getbank?openid='+openid).then(successCallback,errorCallback);
	},

}
}
</script>
<style lang="scss" scoped>
.tc_navx{
	background-color: #00a8d9;
	border-radius: 5px;
	padding: 10px 20px 10px 20px;
}
.tc_nav{
	display: none;
	position: fixed;
	margin-left: 20%;
	text-align: center;
	width: 60%;
/*	height: 30px;*/
	color: #ffffff;
	font-size: 15px;
	bottom: 70%;
}
/**/
.tixiancard{
	float: left;
	width: 80%;
	margin: 60px 10% 0 10%;
	padding: 12px 0 12px 0;
	border-radius: 5px;
	background:url(../../img/ss.png);
  	background-size: cover 100% 100%;
  	background-repeat: no-repeat;
	color: #FFFFFF;
	font-weight: 550;
}
.care{
	float: left;
	width: 100%;
	border-bottom: #eee solid 1px;
	margin-top: 15px;
}
.carea{
	float: left;
	width: 20%;
	text-align: center;
	border-right: #eee solid 1px;
	margin: 5px 0 10px 0;
	font-weight: 550;
}
.careb::placeholder{
	text-align: center;
	font-size: 12px;
}
.careb{
	float: left;
	width: 75%;
	font-size: 12px;
	padding: 5px 0 10px 0;
	text-align: center;
}
.carda{
	float: left;
	width: 20%;
	text-align: center;
	border-right: #eee solid 1px;
	font-weight: 550;
}
.cardb{
	float: left;
	width: 75%;
	text-align: center;
	color: #777;
}
.cardc{
	float: left;
	width: 5%;
}
.card{
	float: left;
	width: 100%;
	border-bottom: #eee solid 1px;
	padding: 5px 0 10px 0;
}
.txa{
	background-color: #FFFFFF;
	padding-top: 15px;
	float: left;
	width: 100%;
}
/*head*/
header{
  height: .4rem;
  background:url(../../img/ss.png);
  background-size:100% 100%;
  background-repeat: no-repeat;
  float: left;
  width: 100%;
  h1{
    margin-top: .2rem;
  }
}
.set_1{
	text-align: center;
    float: left;
    width: 86%;
    font-weight: 600;
    color: #FFFFFF;
    font-size: 19px;
    line-height:0;
}
.set_2{
	float: left;
	margin-left: 3%;
	margin-top: -7px;
	width: 5%;
	color: #FFFFFF;
}
.tx{
	width: 100%;
	background-color: #FFFFFF;
}
</style>


// WEBPACK FOOTER //
// src/components/mine/tixian.vue